import { Col, Row, Radio } from 'antd';

import React, {  useState } from 'react';
import {  isIPSDataCreatorOrAdministrator } from 'utils/UserInfo';
import ConfirmDialog from '../CommonComponent/DialogBox/ConfirmDialogBox';

function IpsWorkCompleteSection({
  project,
  handleProjectDetailUpdate,
  history,
  context,
  isReadOnly,
  phaseDetails,
  phaseId,
  isProjectOnHold,
  isItLastPhase,
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [confirmDialogDetails, setConfirmDialogDetails] = useState({});

  const handleCancel = () => {
    setIsModalOpen(false);
  };
 
  const handleAllIpsWorkComplete = async (value) => {
    if (value === 'N' && project.allIPSComplFlag === 'Y') {
      await handleProjectDetailUpdate('N', 'IPS_COMPL_FLAG', 'string', phaseId);
      history.push(`/dashboard/datatracker_progress`);
      context.setProjectTab('datatracker_progress');
      setIsModalOpen(false);
    } else if (isItLastPhase && value === 'Y') {
      // we are using the response obj to decide if allIPSCompFlag is "Y"
      let response = await handleProjectDetailUpdate(
        value,
        'IPS_COMPL_FLAG',
        'string',
        phaseId
      );

      if (response.allIPSComplFlag === 'Y') {
        
        history.push(`/dashboard/datatracker_complete`);
        context.setProjectTab('datatracker_complete');
        setIsModalOpen(false);
      }
      
    } else {
      await handleProjectDetailUpdate(
        value,
        'IPS_COMPL_FLAG',
        'string',
        phaseId
      );
    }
  };
  const handleUndoCompleteProject = (e) => {
    let value = e.target.value;
    if (value === 'N' && project.allIPSComplFlag === 'Y') {
      setConfirmDialogDetails({
        title: `Do you want to Undo  ${project.stationName} Complete Project?`,
        confirmButtonName: 'Yes,Undo',
        submitFunctionArgs: value,
        handleSubmit: handleAllIpsWorkComplete,
      });
      setIsModalOpen(true);
    } else if (isItLastPhase && value === 'Y') {
      setConfirmDialogDetails({
        title: `Do you want to mark ${project.stationName} as a Complete?`,
        confirmButtonName: 'Yes,Complete',
        submitFunctionArgs: value,
        handleSubmit: handleAllIpsWorkComplete,
      });
      setIsModalOpen(true);
    } else {
      handleAllIpsWorkComplete(value);
    }
  };

  return (
    <>
      <section className='padding-container'>
        <Row>
          <Col xs={24} sm={24} md={24} lg={12} xl={18}>
            <Row>
              <h6 className='control-section'>All IPS Work Complete</h6>

              <Radio.Group
                onChange={handleUndoCompleteProject}
                value={phaseDetails?.ipsComplFlag}
                defaultValue={'N'}
                className='d-flex '
                // disabled={isReadOnly|| isProjectOnHold}
                disabled={!isIPSDataCreatorOrAdministrator() || isProjectOnHold}
              >
                <Radio value={'Y'}>Yes</Radio>
                <Radio value={'N'}>No</Radio>
              </Radio.Group>
            </Row>
          </Col>
          {phaseDetails?.ipsComplChangedDate && (
            <Col>{`${phaseDetails?.ipsComplChangedUser}  ${phaseDetails?.ipsComplChangedDate}`}</Col>
          )}
        </Row>
        <ConfirmDialog
          show={isModalOpen}
          title={confirmDialogDetails.title}
          handleCancel={handleCancel}
          submitFunctionArgs={confirmDialogDetails.submitFunctionArgs}
          handleSubmit={confirmDialogDetails.handleSubmit}
          confirmButtonName={confirmDialogDetails.confirmButtonName}
          cancelButtonName={'No,Cancel'}
        />
      </section>
    </>
  );
}

export default IpsWorkCompleteSection;
